import { useAuthContext } from '@/features/auth/contexts/AuthContext'

import { authSecondaryClassName } from '../../constants/styles'
import { AuthShell } from '../AuthShell'

import { SignUpButton } from './Button'
import { SignUpFields } from './Fields'
import { SignUpForm } from './Form'

interface SignUpProps {
  onSuccess: () => void
}

export const SignUp = ({ onSuccess }: SignUpProps) => {
  const { setAction } = useAuthContext()

  return (
    <AuthShell title="Criar Conta" subtitle="Comece sua jornada no Missão Futuro">
      <SignUpForm onSuccess={onSuccess} className="flex flex-col gap-4">
        <SignUpFields />
        <SignUpButton>Criar Conta</SignUpButton>
        <button
          type="button"
          className={authSecondaryClassName}
          onClick={() => setAction('sign-in')}
        >
          Já tem uma conta? Faça login
        </button>
      </SignUpForm>
    </AuthShell>
  )
}
